import { t } from '../i18n';

/**
 * Password validation utilities
 */

export interface PasswordValidation {
  isValid: boolean;
  hasMinLength: boolean;
  hasUppercase: boolean;
  hasLowercase: boolean;
  hasNumber: boolean;
  hasSpecialCharacter: boolean;
}

/**
 * Validate password against all requirements
 */
export const validatePassword = (password: string): PasswordValidation => {
  const hasMinLength = password.length >= 8;
  const hasUppercase = /[A-Z]/.test(password);
  const hasLowercase = /[a-z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialCharacter = /[!@#$%^&*(),.?":{}|<>]/.test(password);

  return {
    isValid: hasMinLength && hasUppercase && hasLowercase && hasNumber && hasSpecialCharacter,
    hasMinLength,
    hasUppercase,
    hasLowercase,
    hasNumber,
    hasSpecialCharacter,
  };
};

/**
 * Get password validation error message
 */
export const getPasswordErrorMessage = (validation: PasswordValidation): string => {
  if (validation.isValid) return '';

  const missing: string[] = [];
  if (!validation.hasMinLength) missing.push(t('password.minLength'));
  if (!validation.hasUppercase) missing.push(t('password.uppercase'));
  if (!validation.hasLowercase) missing.push(t('password.lowercase'));
  if (!validation.hasNumber) missing.push(t('password.number'));
  if (!validation.hasSpecialCharacter) missing.push(t('password.specialCharacter'));

  return t('password.mustContain', { requirements: missing.join(', ') });
};
